<template>
  <div>
    <div v-if="isAllowed" class="wrapper-content w-100" id="visadoparcelario-consulta">
      <hr>
      <h2>{{title}}</h2>
      <h4>{{subTitle}}</h4>
      <div>
        <LmBreadcrumb v-if="showBreadcrumb" />
        <LmForm ref="lmFormRef">
          <LmComponentLoading v-if="isLoading"/>
          <div class="row">
            <LmNumberInputGroup
              autofocus
              class="col-12 col-lg-6"
              v-model="form.numeroDocumento"
              :v="$v.form.numeroDocumento"
              label="Documento"
              placeholder="Solo números"
              :buttonName="$t('search')"
              @click="search"
              :isProcessing="formIsProcessing"
              />
          </div>
          <hr>
          <b-card v-if="formIsProcessing">
            <b-skeleton animation="wave" width="85%"></b-skeleton>
            <b-skeleton animation="wave" width="55%"></b-skeleton>
            <b-skeleton animation="wave" width="70%"></b-skeleton>
          </b-card>
          <div v-if="!isLoading && !formIsProcessing">
            <div
              v-for="(vecino, index) in vecinos" :key="index"
              class="row mb-4"
            >
              <template v-for="(value, key, vecinoIndex) in vecino">
                <LmLeaFletMap v-if="key === 'latLong'"
                  :key="vecinoIndex"
                  :markerLatLng="vecinos[index][key]"
                  :centerMapCoordinate="vecinos[index][key]"
                  class="col-12"
                  />
                <LmTextInput
                  v-else
                  :key="vecinoIndex"
                  class="col-4"
                  v-model="vecinos[index][key]"
                  :label="key"
                  :disabled="true"
                />
              </template>
            </div>
          </div>
          <div class="row" v-if="formIsProcessing || innerIsLoading" >
            <div class="col-12">
              <hr>
              <b-skeleton-table
                :rows="5"
                :columns="4"
                :table-props="{ bordered: true, striped: true }"
                ></b-skeleton-table>
            </div>
          </div>
          <div class="row" v-else-if="casos.rows.length">
            <div class="col-12"><hr></div>
            <LmTable
              class="mt-2"
              :content="casos"
              :showHeaderTable="true"
              :hideHeadersBelowRows="true"
            />
          </div>
          <div class="row" v-if="!formIsProcessing && vecinoNoEncontrado">
            <b-col cols="12">
              <b-alert show variant="danger">Vecino no encontrado</b-alert>
            </b-col>
          </div>
          <LmButton
            id="cancel-button"
            type="button"
            buttonClass="btn-secondary"
            :isProcessing="formIsProcessing"
            :value="$t('Cancel')"
            @click.native="cancelBtn"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-2"
            lmButtonWrapperClass="col"
            />
          <router-link v-if="vecinoNoEncontrado" :to="newOrEditVecinoPath">
            <LmButton
              id="nuevo-tramite-button"
              type="button"
              buttonClass="btn-success"
              :isProcessing="formIsProcessing"
              :value="$t('Nuevo Vecino')"
              lmButtonRootWrapperClass="d-inline-block mr-1 mt-2"
              lmButtonWrapperClass="col"
              />
          </router-link>
          <router-link v-if="vecinos.length" :to="newOrEditTramitePath">
            <LmButton
              id="nuevo-tramite-button"
              type="button"
              buttonClass="btn-success"
              :isProcessing="formIsProcessing"
              :value="$t('Nuevo Trámite')"
              lmButtonRootWrapperClass="d-inline-block mr-1 mt-2"
              lmButtonWrapperClass="col"
              />
          </router-link>
        </LmForm>
      </div>
    </div>
<!--     <LmListV2
      v-if="isAllowed"
      ref="lmlistv2"
      :listEndpointUri=listEndpointUri
    /> -->
    <div v-else class="wrapper-content w-100">
      <LmError
        title="Lo sentimos"
        :subtitle="'No puede ver esta página'"
      />
    </div>
  </div>
</template>

<script>
import commonsApi from '@/api/commons'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LmForm from '@/components/form/LmForm.vue'
import LmButton from '@/components/form/elements/LmButton'
import LmNumberInputGroup from '@/components/form/elements/LmNumberInputGroup'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmTextInput from '@/components/form/elements/LmTextInput'
import lmToasts from '@/mixins/lmToasts.js'
import LmListV2 from '@/components/LmListV2'
import LmTable from '@/components/LmTable'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
import LmError from '@/components/LmError'
import LmLeaFletMap from '@/components/LmLeaFletMap.vue'

export default {
  mixins: [lmSuperPowerSelectHelper, lmToasts],
  components: {
    LmForm,
    LmButton,
    LmTextInput,
    LmNumberInput,
    LmNumberInputGroup,
    LmListV2,
    LmSuperPowerSelect,
    LmError,
    LmLeaFletMap,
    LmTable
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      isLoading: true,
      innerIsLoading: false,
      isAllowed: true,
      form: {
        numeroDocumento: null
      },
      initialForm: {},
      vecinoNoEncontrado: false,
      casos: {
        tableTitle: 'Trámites',
        columns: 12,
        rows: []
      },
      formIsProcessing: false,
      vecinos: []
    }
  },
  computed: {
    newOrEditTramitePath: {
      get () {
        return `/${this.newOrEditPath}/${this.form.numeroDocumento}`
      },
      set () {}
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
    vecinoEndpointUri: {
      type: String,
      required: true
    },
    listEndpointUri: {
      type: String,
      required: true
    },
    newOrEditPath: {
      type: String,
      required: true
    },
    newOrEditVecinoPath: {
      type: String,
      required: true
    }
  },
  validations () {
    return {
      form: {
        numeroDocumento: {
          required
        }
      }
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings']),
    cancelBtn () {
      this.$router.go(-1)
    },
    async search () {
      try {
        this.formIsProcessing = true
        const resp = await commonsApi.axiosGetWrapper(`${this.vecinoEndpointUri}${this.form.numeroDocumento}`)
        if (Array.isArray(resp.data) && resp.data.length) {
          this.innerIsLoading = true
          this.vecinoNoEncontrado = false
          this.vecinos = resp.data
          commonsApi.axiosGetWrapper(`${this.listEndpointUri}${this.form.numeroDocumento}`)
            .then(r => {
              this.casos.rows = []
              this.innerIsLoading = false
            })
            .catch(e => {
              this.casos.rows = []
              this.innerIsLoading = false
            })
        } else {
          this.vecinoNoEncontrado = true
          this.vecinos = []
          this.casos.rows = []
        }
      } catch (e) {
        console.log(e)
        this.vecinoNoEncontrado = true
        this.vecinos = []
      } finally {
        this.formIsProcessing = false
      }
    }
  },
  created () {
    this.isLoading = false
    this.initialForm = JSON.stringify(this.form)
  }
}
</script>
